import createReactComponent from '../createReactComponent';
var QrCode = createReactComponent('QrCode', [['rect', {
  x: '2',
  y: '2',
  width: '8',
  height: '8',
  key: 'bswmnx'
}], ['path', {
  d: 'M6 6h.01',
  key: '1utrut'
}], ['rect', {
  x: '14',
  y: '2',
  width: '8',
  height: '8',
  key: 'ia6yqy'
}], ['path', {
  d: 'M18 6h.01',
  key: '1v4wsw'
}], ['rect', {
  x: '2',
  y: '14',
  width: '8',
  height: '8',
  key: '153n5c'
}], ['path', {
  d: 'M6 18h.01',
  key: 'uhywen'
}], ['path', {
  d: 'M14 14h.01',
  key: 'uax65s'
}], ['path', {
  d: 'M18 18h.01',
  key: 'mvaupc'
}], ['path', {
  d: 'M18 22h4v-4',
  key: '18iokt'
}], ['path', {
  d: 'M14 18v4',
  key: 'mjvy8p'
}], ['path', {
  d: 'M22 14h-4',
  key: 'ksfyo3'
}]]);
export default QrCode;